<template>
<div class="overflow-auto">
  <b-form-fieldset horizontal class="col-6">
    <b-form-input v-model="filter" placeholder="Rechercher un point d'enquête"></b-form-input>
  </b-form-fieldset>
  <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" aria-controls="surveyPointsListTable"></b-pagination>
  <b-table id="surveyPointsListTable" striped hover :fields="fields" :filter-included-fields="selectedFields" :items="surveyPointsList" :per-page="perPage" :current-page="currentPage" :filter="filter">
    <template v-slot:cell(informant)="data">
               <b-button  v-b-tooltip title="Afficher les données sur le(s) informateur(s)" variant="transparent" v-b-toggle="'collapse' + data.item.spIdentifier"><informerIcon></informerIcon></b-button>
        <b-collapse :id="'collapse' + data.item.spIdentifier" class="mt-2">
        <b-card>
          <p class="card-text">
            <b-list-group>
              <b-list-group-item v-for="(infoTemoin, index) in data.item.infosTemoins" :key="index">
                Informateur n°{{ index + 1 }}: {{infoTemoin}}
              </b-list-group-item>
              <b-list-group-item>Date: {{data.item.dateEnquete | formatDate}} </b-list-group-item>
            </b-list-group>
          </p>
        </b-card>
      </b-collapse>
            <b-button  v-b-tooltip title="Afficher le carnet sur Gallica"  variant="transparent" v-if="data.item.gallicaNoteBookLink != 'pas de Carnet'">
          <b-link :href="data.item.gallicaNoteBookLink" style="color: black" target="blank"><BookNoteIcon></BookNoteIcon></b-link>
      </b-button> 
      </template>
    <template v-slot:cell(actions)="data">

      <b-button  v-b-tooltip title="Afficher dans le visualiseur" variant="transparent" @click="showMap(data.item.imageLink)">
        <eyeIcon></eyeIcon>
      </b-button>
 
      </template>
      <template v-slot:cell(externalLinks)="data">    
      <a v-if="data.item.dbPediaLink != 'doesNotExist'" :href="data.item.dbPediaLink" target="blank">
        <img src="../../assets/logos/DBpediaLogo.png" alt="logo DBPedia" id="logoDBPedia" class="img-fluid logoExternalLink" />
      </a>
      <a v-if="data.item.bnfLink != 'doesNotExist'" :href="data.item.bnfLink" target="blank">
        <img src="../../assets/logos/BNFLogo.png" id="logoBNF" alt="logo BNF"  class="img-fluid logoExternalLink" />
      </a>
    </template>

   </b-table>
  <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" aria-controls="surveyPointsListTable"></b-pagination>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import EventBus from '@components/bus/bus.js';
import EyeIcon from '@components/icons/EyeIcon'
import InformerIcon from '@components/icons/InformerIcon'
import BookNoteIcon from '@components/icons/BookNoteIcon'

export default {
  name: 'survey-points-search',
  components: { EyeIcon, InformerIcon, BookNoteIcon },
  data() {
    return {
      perPage: 500,
      currentPage: 1,
      rows: null,
      filter: null,
      selectedFields: ['spIdentifier', 'placeName'],
      fields: [
        { key: 'spIdentifier', label: 'Identifiant' },
        { key: 'placeName', label: 'Localité' },
        { key: 'country', label: 'Pays' },
        { key: 'informant', label: 'Informateur' },
        { key: 'actions', label: 'Actions' },
        { key: 'externalLinks', label: 'Liens Externes' }
      ]
    }
  },
  computed: {
    ...mapGetters({
      surveyPointsList: 'getSurveyPointsList'
    })
  },
  created: function() {
    this.rows = this.surveyPointsList.length
  },
  methods: {
    // Fonction appelée lorsque l'utilisateur souhaite visualiser la localisation d'un point d'enquête dans la "Carte N° I :  NOMS FRANÇAIS DES LOCALITÉS"
    showInventoryEntry: function(value) {
      // Carte 000I - Noms français des localités
      this.$store.dispatch('updateIndex', 2021)
      this.$store.dispatch('findInventoryEntry', "http://purl.org/fr/eclats/resource/inventoryEntry_SP" + value.item.spIdentifier + "_map000I")
      this.$router.push('visualiseur')
    }
  }
}
</script>
<style>
/*
plus utilisé, on utilise à la place la classe de style logoExternalLink définie dans MapTableResult.vue
#externalLinks_logos{
  width: 50px;
}
*/
</style>



// WEBPACK FOOTER //
// src/components/search/SurveyPointsSearch.vue